import { CardGrid } from '../../components/CardGrid';
import { Carousel } from '../../components/Carousel';
import { ItemCard } from '../../components/ItemCard';
import { GridHeading, RecommendationsWrapper } from './Recommendations.styles';
import type { RecommendationItem, RecommendationsProps } from './Recommendations.types';

function renderItemCard(
  item: RecommendationItem,
  {
    fromPriceLabel,
    noImageLabel,
    onSelect,
  }: { fromPriceLabel: string; noImageLabel: string; onSelect?: (id: string) => void }
) {
  return (
    <ItemCard
      key={item.id}
      image={{ src: item.imageUrl, alt: item.name, placeholderLabel: noImageLabel }}
      imageOverlay
      title={item.name}
      meta={item.meta}
      price={
        item.price
          ? {
              amount: item.price.amount,
              currencyCode: item.price.currencyCode,
              label: fromPriceLabel,
              discount: item.discount,
            }
          : undefined
      }
      ariaLabel={item.name}
      onSelect={onSelect ? () => onSelect(item.id) : undefined}
    />
  );
}

export function Recommendations({
  items,
  onSelect,
  title = 'You might also like',
  fromPriceLabel = 'From',
  noImageLabel = 'No image',
  visibleCount = { mobile: 1.2, desktop: 2 },
  layout = 'carousel',
  columns = 2,
  mobileColumns = 2,
}: RecommendationsProps) {
  if (items.length === 0) return null;

  const cardOptions = { fromPriceLabel, noImageLabel, onSelect };

  if (layout === 'grid') {
    return (
      <RecommendationsWrapper>
        {title && <GridHeading>{title}</GridHeading>}
        <CardGrid $columns={columns} $mobileColumns={mobileColumns}>
          {items.map((item) => renderItemCard(item, cardOptions))}
        </CardGrid>
      </RecommendationsWrapper>
    );
  }

  return (
    <RecommendationsWrapper>
      <Carousel title={title} visibleCount={visibleCount} showProgress>
        {items.map((item) => renderItemCard(item, cardOptions))}
      </Carousel>
    </RecommendationsWrapper>
  );
}
